// extracted by mini-css-extract-plugin
export default {"store_container":"Store_store_container__SI7Kn","products_container":"Store_products_container__cmUxs"};